import * as React from 'react';
import { HomeProps } from './Home';
import { useOrganisationStore } from 'Global/Organisations/OrganisationsStore';
import { isNullOrUndefined } from 'Util/TypeGuards';
import MultiOrgHomeBookingTypeSelection from './MultiOrgHomeBookingTypeSelection';
import MultiOrgHomeOrgSelection from './MultiOrgHomeOrgSelection';

function MultiOrgHome({ contactUs }: HomeProps) {
	const orgStore = useOrganisationStore();
	const [showOrganisationSelection, setShowOrganisationSelection] = React.useState(
		(orgStore.organisations?.length ?? 0) > 1 && isNullOrUndefined(orgStore.selectedOrganisation),
	);

	return (
		<>
			<MultiOrgHomeBookingTypeSelection contactUs={contactUs} show={!showOrganisationSelection} />
			<MultiOrgHomeOrgSelection
				show={showOrganisationSelection}
				setShowOrganisationSelection={setShowOrganisationSelection}
			/>
		</>
	);
}

export default MultiOrgHome;
